module.exports = __webpack_public_path__ + "static/media/admin_panel_settings_white_24dp.ba06abcf.svg";